import { createContext } from "react";

export default createContext({ transformUrl: (url) => url });
